// @flow
import {request, digestRequest} from './base'

import type {
  AccessTokenResponse,
  LoginParams,
  DeviceInfo
} from 'modules/Authenticate/types/index'

export const login = (
  params: LoginParams,
  isFirstTime: boolean
): Promise<any> => {
  const body = {}
  return digestRequest(
    'authentication/login',
    {
      method: 'POST',
      body: JSON.stringify(body)
    },
    params,
    isFirstTime
  )
}

export const logout = (): Promise<any> => {
  const body = {}
  return request(
    'authentication/admin/logout',
    {
      method: 'POST',
      body: JSON.stringify(body)
    },
    false,
    true
  )
}

export const verifyLogin = (
  ticket: string,
  passcode: string,
  userId: string,
  companyId: string
): Promise<AccessTokenResponse> => {
  const body = {
    ticket,
    passcode,
    userId,
    companyId,
    role: 'EXPERT'
  }

  return request(
    'authentication/login/mfa/verify',
    {
      method: 'POST',
      body: JSON.stringify(body)
    },
    true
  )
}

export const otpResend = (ticket: string): Promise<{success: boolean}> => {
  const body = {
    ticket
  }

  return request(
    'authentication/login/mfa/resend',
    {
      method: 'POST',
      body: JSON.stringify(body)
    },
    true
  )
}

export const bindDevice = (device: DeviceInfo): Promise<{success: boolean}> => {
  const body = {
    device
  }

  return request(
    'device_management/devices',
    {
      method: 'POST',
      body: JSON.stringify(body)
    },
    true
  )
}
